import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import theme from "../../data/theme";
import shopApi from "../../api/shop";
import { toast } from "react-toastify";

export default function AccountAskEmail() {
    const [email, setEmail] = useState();

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = () => {
        shopApi.forgotPassword(email).then((response) => {
            setEmail("");
            toast.success(
                "Votre demande de réinitialisation de mot de passe a été envoyée. Un lien a été envoyé à votre adresse de courriel pour vous permettre de définir un nouveau mot de passe et de vous connecter.",
                {
                    theme: "colored",
                    autoClose: 20000,
                }
            );
        });
    };

    return (
        <div className="block">
            <Helmet>
                <title>{`Profile — ${theme.name}`}</title>
            </Helmet>
            <div className="block" />
            <div className="container">
                <div className="mt-4 mt-md-0">
                    <div className="card flex-grow-1 mb-0">
                        <div className="card-body">
                            <label htmlFor="email">Email Address</label>
                            <input
                                id="email"
                                type="email"
                                className="form-control"
                                value={email}
                                onChange={handleChange}
                                placeholder="Email Address"
                            />
                            <div>
                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    className="btn btn-primary mt-2 mt-md-3 mt-lg-4"
                                >
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
